import {
  Box,
  Flex,
  Icon,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Td as ChakraTd,
  Tr as ChakraTr,
  TableContainer,
  Tooltip,
} from '@chakra-ui/react'
import { Td, Tr } from '../../../../../../components/Table'
import { FaCheckCircle } from 'react-icons/fa'
import { CustomTooltip } from '../../../../../../components/CustomTooltip'
import { AiOutlineLink } from 'react-icons/ai'

export function Item({ data, odd }) {
  return (
    <Tr border="none">
      <Td
        borderRight="1px solid #CFCFCF"
        bgColor={odd ? '#EDF2F7' : 'white'}
        py={0}
      >
        {data.data_envio}
      </Td>
      <Td
        borderRight="1px solid #CFCFCF"
        bgColor={odd ? '#EDF2F7' : 'white'}
        py={0}
      >
        <Text as="a" href={data.link_proposta} target="_blank" textDecor="underline" color="#378BBF">
          {data.numero_pedido}
        </Text>
      </Td>
      <Td
        py={0}
        borderRight="1px solid #CFCFCF"
        bgColor={odd ? '#EDF2F7' : 'white'}
      >
        <Flex gap={2} alignItems="center" position="relative">
          <Flex flexDirection="column" alignItems="center" w="100%">
            <Tooltip label={data?.consultor}>
              <Text isTruncated textTransform={'capitalize'} textAlign="center">
                {data?.consultor}
              </Text>
            </Tooltip>
          </Flex>
          {data?.pedido_especial === '1' && (
            <Icon
              as={FaCheckCircle}
              color="#378BBF"
              fontSize="20px"
              position="absolute"
              top="50%"
              transform="translateY(-50%)"
              right="-1"
            />
          )}
        </Flex>
      </Td>
      {/* 378BBF */}
      <Td
        py={0}
        h="36px"
        borderRight="1px solid #CFCFCF"
        bgColor={odd ? '#EDF2F7' : 'white'}
      >
        {data.valor_proposta}
      </Td>
      <Td
        py={0}
        borderRight="1px solid #CFCFCF"
        bgColor={odd ? '#EDF2F7' : 'white'}
      >
        <CustomTooltip
          label={
            <Box
              h="16px"
              px={2}
              bgColor="#378BBF"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize="12px"
              color="white"
            >
              {data?.info_itens?.length} itens
            </Box>
          }
          bg="#fff"
          color="black"
          fontSize="12px"
        >
          <TableContainer>
            <Table size="sm">
              <Thead>
                <ChakraTr>
                  <Th>Cod</Th>
                  <Th>Cor</Th>
                  <Th isNumeric>Qtd</Th>
                </ChakraTr>
              </Thead>
              <Tbody>
                {data?.info_itens?.map((item, index) => (
                  <ChakraTr
                    bgColor="white!important"
                    fontSize="12px"
                    fontWeight="normal"
                    key={index}
                  >
                    <ChakraTd
                      bgColor="white!important"
                      fontSize="12px"
                      fontWeight="normal"
                    >
                      {item.codigo_produto}
                    </ChakraTd>
                    <ChakraTd
                      bgColor="white!important"
                      fontSize="12px"
                      fontWeight="normal"
                    >
                      {item.nome_cor}
                    </ChakraTd>
                    <ChakraTd
                      bgColor="white!important"
                      fontSize="12px"
                      fontWeight="normal"
                    >
                      {item.quantidade_itens}
                    </ChakraTd>
                  </ChakraTr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </CustomTooltip>
      </Td>
      <Td
        py={0}
        borderRight="1px solid #CFCFCF"
        bgColor={odd ? '#EDF2F7' : 'white'}
      >
        {data.desconto === 'S' && (
          <Flex justifyContent="center" alignItems="center" h="100%">
            <Icon as={FaCheckCircle} color="#76BF37" fontSize="20px" />
          </Flex>
        )}
      </Td>
      <Td
        py={0}
        borderRight="1px solid #CFCFCF"
        bgColor={odd ? '#EDF2F7' : 'white'}
      >
        {data.verba}
      </Td>
      <Td
        py={0}
        borderRight="1px solid #CFCFCF"
        bgColor={odd ? '#EDF2F7' : 'white'}
      >
        {data.prazo ? `${data.prazo} dias` : ''}
      </Td>
      <Td py={0} bgColor={odd ? '#EDF2F7' : 'white'}>
        <Text as="a" href={data.link_proposta} target="_blank" rel="noreferrer">
          <Icon as={AiOutlineLink} color="#76BF37" fontSize="20px" />
        </Text>
      </Td>
    </Tr>
  )
}
